import styled from "@emotion/styled";
import { Heading } from "nectar-ui";

export const CustomHeading = styled(Heading)`
  letter-spacing: 0;
`;
